export default __webpack_public_path__ + "static/media/EN_05.3e09d987.svg";